var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"rodape"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-1-1"},[_vm._v(" © Copyright © 2022 Todos os direitos reservados. "),_c('br'),_vm._v(" Portal desenvolvido por "),_c('a',{attrs:{"href":"#"}},[_vm._v("Tempo Brasil")]),_vm._v(". ")])])])])
}]

export { render, staticRenderFns }